import { Box, IconButton, Tooltip } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import Icons from '../../../components/icons';
import { SchoolDeclarationType } from '../types';

export const getDeclarationSetupTableColumns = (
  onEdit: (rowDeclarationData: SchoolDeclarationType) => void,
  onDelete: (rowDeclarationData: SchoolDeclarationType) => void
): GridColDef[] => {
  return [
    { field: 'grade', headerName: 'Grade', flex: 1 },
    {
      field: 'declarations',
      headerName: 'No. of Declarations',
      flex: 1,
      renderCell: (params) => {
        return <Box>{params.row.declarations.length}</Box>;
      }
    },
    {
      field: 'edit',
      headerName: 'Actions',
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      minWidth: 160,
      renderCell: (params) => (
        <Box>
          <Tooltip title='Edit'>
            <IconButton onClick={() => onEdit(params.row)}>
              <Icons.EditBlackOutlined />
            </IconButton>
          </Tooltip>
          <Tooltip title='delete'>
            <IconButton onClick={() => onDelete(params.row)}>
              <Icons.Delete />
            </IconButton>
          </Tooltip>
        </Box>
      )
    }
  ];
};
